import { render, staticRenderFns } from "./ChefsChoiceDemand.vue?vue&type=template&id=db7b409a&scoped=true&"
import script from "./ChefsChoiceDemand.vue?vue&type=script&lang=js&"
export * from "./ChefsChoiceDemand.vue?vue&type=script&lang=js&"
import style0 from "./ChefsChoiceDemand.vue?vue&type=style&index=0&id=db7b409a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db7b409a",
  null
  
)

export default component.exports